// API base URL

// 192.168.0.130
// export const BASE_URL = 'https://115.160.148.11:8080/api/v1/ivms/ivms';

// 192.168.0.156
// export const BASE_URL = 'https://192.168.0.156:8080/api/v1/ivms/ivms';

// 192.168.0.216
export const BASE_URL = "https://ivms.ddnsfree.com:8080/api/v1/ivms/ivms";

// AWS
// export const BASE_URL = "https://www.weltek-ivms.com:8080/api/v1/ivms/ivms";

export const API_CALL_INTERVAL = 2000;

export const ARCHIVED_DAYS = 30;
